import { useRef, useState, useEffect } from "react"

// Hook
export function useHover({ setHoverIndex, rowIndex }) {
  const [value, setValue] = useState(false)

  const ref = useRef(null)

  const handleMouseOver = () => {
    setValue(true)
    setHoverIndex(rowIndex)
  }
  const handleMouseOut = () => {
    setValue(false)
    setHoverIndex(null)
  }

  useEffect(
    // eslint-disable-next-line consistent-return
    () => {
      const node = ref.current
      if (node) {
        node.addEventListener(`mouseover`, handleMouseOver)
        node.addEventListener(`mouseout`, handleMouseOut)

        return () => {
          node.removeEventListener(`mouseover`, handleMouseOver)
          node.removeEventListener(`mouseout`, handleMouseOut)
        }
      }
    },
    [ref.current], // Recall only if ref changes
  )

  return [ref, value]
}
